import React from 'react'
import logo from '../../assets/favDoctor-logo.svg'
import './LoginHeader.css';
import {Link } from "react-router-dom";


export default function LoginHeader(){
    return<div className='LoginHeader'>
       <Link to='/'> <img src={logo} alt={logo} /></Link>
    </div>
}